import React from 'react';
import style from './accountMenu.module.scss';
import classNames from 'classnames';
import { LoginButton } from 'acscp/components/auth/loginButton';
import { SetOpenMenu } from 'acscp/actions';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { AppState, Menu } from 'acscp/store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Background, Row } from 'acscp/components/common/row';
import { FormattedMessage } from 'react-intl';
import { ACS_WEBSITE } from 'acscp/settings/appSettings';
import {Link} from 'react-router-dom';
import {
    userCanAccessCharters,
    userCanAccessLoyalty,
    userCanPotentiallyRequestFlights,
    userIsLoggedIn
} from 'acscp/store/helpers/authHelper';
import { LanguageMenuButton } from 'acscp/components/intl/languageMenuButton';
import { chartersList, newFlightRequest } from 'acscp/components/routeHelper';

interface AccountMenuOwnProps {
    useStickyHeader: boolean;
}

interface AccountMenuStateProps {
    isLoggedIn: boolean;
    isNonJetPortalUser: boolean;
    canAccessCharters: boolean;
    canAccessLoyalty: boolean;
    canPotentiallyRequestFlights: boolean;
    mainSiteLink?: string;
}

interface AccountMenuDispatchProps {
    openCustomerDetailsMenu: () => void;
    openLanguageMenu: () => void;
}

export class AccountMenuPresentational extends PresentationComponentBase<AccountMenuOwnProps,
    AccountMenuStateProps, AccountMenuDispatchProps, {}> {
    render(): JSX.Element {
        return (
            <nav className={classNames(style.AccountMenu, {[style.StickyHeader]: this.props.useStickyHeader})}>
                <Row className={style.Container} background={Background.Grey}>
                    {this.props.canPotentiallyRequestFlights &&
                        <span className={classNames(style.ListItem, style.NewEnquiry)}>
                            <Link to={newFlightRequest()}>
                                <FormattedMessage
                                    id={'web.components.common.accountMenu.newEnquiry'}
                                    defaultMessage={'NEW ENQUIRY'}
                                />
                            </Link>
                        </span>
                    }
                    {this.props.canAccessCharters &&
                    <span className={style.ListItem}>
                            <Link to={chartersList()}>
                                <FormattedMessage
                                    id={'web.components.common.accountMenu.myCharters'}
                                    defaultMessage={'MY CHARTERS'}
                                />
                            </Link>
                        </span>
                    }
                    {this.props.canAccessLoyalty &&
                    <span className={style.ListItem}>
                            <Link to={'/loyalty'}>
                                <FormattedMessage
                                    id={'web.components.common.accountMenu.myRewards'}
                                    defaultMessage={'MY REWARDS'}
                                />
                            </Link>
                        </span>
                    }
                    <span className={style.ListItem}>
                        <a
                            href={this.props.mainSiteLink || ACS_WEBSITE}
                            target={'_blank'}
                        >
                            <FormattedMessage
                                id={'web.components.common.accountMenu.mainSite'}
                                defaultMessage={'ACS MAIN SITE'}
                            />
                        </a>
                    </span>
                    {this.props.isLoggedIn &&
                        <span className={style.ListItem}>
                            <a href="javascript:;" id="Select" onClick={this.props.openCustomerDetailsMenu}>
                                <FormattedMessage
                                    id={'web.components.common.accountMenu.myAccount'}
                                    defaultMessage={'MY ACCOUNT'}
                                />
                            </a>
                        </span>
                    }
                    {ALLOW_LANGUAGE_SELECTION &&
                        <span className={style.ListItem}>
                            <a href="javascript:;" id="SelectLanguage" onClick={this.props.openLanguageMenu}>
                                <LanguageMenuButton/>
                            </a>
                        </span>
                    }
                    {!this.props.isLoggedIn && !this.props.isNonJetPortalUser &&
                        <span className={style.ListItem}><LoginButton /></span>
                    }
                </Row>
            </nav>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): AccountMenuDispatchProps {
    return {
        openCustomerDetailsMenu: () => dispatch(new SetOpenMenu(Menu.CustomerContactDetails)),
        openLanguageMenu: () => dispatch(new SetOpenMenu(Menu.Language))
    };
}

function mapStateToProps(state: AppState, ownProps: {}): AccountMenuStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth),
        isNonJetPortalUser: state.auth.isNonJetPortalUser,
        canAccessCharters: userCanAccessCharters(state.auth),
        canAccessLoyalty: userCanAccessLoyalty(state.auth),
        canPotentiallyRequestFlights: userCanPotentiallyRequestFlights(state.auth),
        mainSiteLink: state.customerContact.mainSiteLink,
    };
}

export const AccountMenu = connect(mapStateToProps, mapDispatchToProps)(AccountMenuPresentational);
